/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class ProfileStatusHistoryEntity extends Entity {
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  previousProfileStatus: string | null = null;
  profileStatus: string | null = null;
  profileStatusLastUpdatedBy: string | null = null;
  profileStatusUpdatedAt: string | null = null;
  updatedAt: string | null = null;
  static override key = 'ProfileStatusHistory';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'ProfileStatusHistory' in input
    ) {
      const { ProfileStatusHistory: wrapped, ...rest } = input as {
        ProfileStatusHistory: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}